// extracted by mini-css-extract-plugin
module.exports = {"carouselWrapper":"gjEMkj","carousel":"rXuzrx","showArrowsOnHover":"l3UA1A","arrow":"DIFPWv"};